<template>
  <div role="group" class="sb-dropdown-group" :data-testid="dataTestid">
    <p
      v-if="title?.length"
      class="sb-dropdown-group__title"
      :data-testid="`${dataTestid}-title`"
    >
      {{ title }}
    </p>
    <slot />
  </div>
</template>

<script setup lang="ts">
export type DropdownGroupProps = {
  /**
   * The title of the dropdown group
   */
  title: string

  /**
   * The data-testid attribute
   */
  dataTestid?: string
}

defineProps<DropdownGroupProps>()
</script>
